module.exports = __webpack_public_path__ + "images/emoji/relaxed.6f7e67f69f463574da81.png";